import { createApi, type BaseQueryFn } from '@reduxjs/toolkit/query/react';
import RequestLimitter from '_services/Api/_utils/RequestLimitter';
import type { AxiosError } from 'axios'; // Import AxiosError type
import {
    callWithRequestLimiter,
    type AxiosRequestShape,
} from './callWithRequestLimiter'; // Import the original function and type

declare global {
    interface Window {
        removeRequestLimitterJobs: (typeof RequestLimitter)['removeRequests'];
    }
}

// Wrapper function conforming to BaseQueryFn
const axiosBaseQuery =
    (): BaseQueryFn<AxiosRequestShape, unknown, unknown> =>
    async (requestArgs) => {
        try {
            // Directly call the original function which returns AxiosResponse
            const result = await callWithRequestLimiter(requestArgs);
            // Return RTK Query success format
            return { data: result.data };
        } catch (error) {
            const axiosError = error as AxiosError;
            return {
                error: {
                    status: axiosError.response?.status,
                    data: axiosError.response?.data,
                    message: axiosError.message,
                    code: axiosError.code,
                },
            };
        }
    };

// initialize an empty api service that we'll inject endpoints into later as needed
const BaseApi = createApi({
    baseQuery: axiosBaseQuery(), // Use the new wrapper
    reducerPath: 'knitandnote/reducer',
    endpoints: () => ({}),
});

export default BaseApi;
